module.exports = __webpack_public_path__ + "static/media/logo-nghiadung.2cd3d22f.svg";